<template>
  <div class="add-keyword-input">
    <ElInput
      :value="query"
      v-bind="$attrs"
      @input="updateQuery"
      v-on="$listeners"
    >
      <MatchingTypeSelect
        slot="append"
        :value="matchingType"
        @input="updateMatchingType"
      />
    </ElInput>
    <div
      v-if="showMatchTypeDescription"
      class="add-keyword-input__matching-type-description"
    >
      <MatchingTypeHelp />
    </div>
  </div>
</template>

<script>
import MatchingTypeSelect from './MatchingTypeSelect';
import MatchingTypeHelp from '../MatchingTypeHelp';

export default {
  name: 'AddKeywordInput',
  components: {
    MatchingTypeSelect,
    MatchingTypeHelp,
  },
  inheritAttrs: false,
  props: {
    matchingType: {
      type: String,
      required: true,
    },
    query: {
      type: String,
      required: true,
    },
    showMatchTypeDescription: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    updateMatchingType(matchingType) {
      this.$emit('update:matchingType', matchingType);
    },
    updateQuery(query) {
      this.$emit('update:query', query);
    },
  },
};
</script>

<style lang="scss">
.add-keyword-input {
  width: 100%;
  position: relative;
  display: inline-block;

  .el-select .el-input {
    width: rem-calc(130px);
  }

  &__matching-type-description {
    display: flex;
    justify-content: flex-end;
    margin-top: $global-margin;
  }
}
</style>
